import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { AdUnitInformation } from '../../../advertising/advertising.routing'
import { LazyTokyoPodcastPage } from './TokyoPodcastPage.lazy'

export interface TokyoPodcastPageRouteProps {
    adUnit?: AdUnitInformation['data']
    twlLogoAdUnit?: AdUnitInformation['data']
}

export const TokyoPodcastPageRegistration = createRegisterableComponent(
    'tokyo-podcast-player-page',
    (props: TokyoPodcastPageRouteProps, services) => {
        const shareUrl = services.config.publicUrl + services.location.pathname
        return (
            <LazyTokyoPodcastPage
                shareUrl={shareUrl}
                onEvent={services.onEvent}
            />
        )
    },
)
